"use client";

import React from "react";
import { Check } from "lucide-react";
import { excursionTerms } from "@/lib/excursionTerms";
const benefits = ["Privater Hoteltransfer", "Preise auf Anfrage & per WhatsApp", "Direkte Anfrage per WhatsApp", excursionTerms.de.chip];
export default function WhyBookWithUs() {
  return <section id="whybookwithus" data-nav="light" className="bg-secondary/40 text-foreground py-6 sm:py-8 border-y border-border">
      <div className="max-w-[1136px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-wrap items-center justify-center gap-3 sm:gap-4 lg:gap-5">
          {benefits.map((benefit, index) => <div key={index} data-index={index} className="inline-flex items-center gap-2.5 px-3.5 py-2 sm:px-4 sm:py-2.5 bg-background border border-border rounded-lg shadow-2xs text-xs sm:text-sm font-medium text-foreground transition-colors hover:border-primary/60">
              <div className="flex items-center justify-center size-5 rounded-lg bg-primary text-primary-foreground shrink-0">
                <Check className="size-3.5 stroke-[2.5]" aria-hidden="true" />
              </div>
              <span className="leading-tight">{benefit}</span>
            </div>)}
        </div>
      </div>
    </section>;
}